import React, { Fragment } from 'react';
import { Container } from 'react-bootstrap';
import HeaderLogged from '../../../components/header_logged'
import Footer from '../../../components/footer'
import Head from '../../../components/head';
import ControleLogged from '../../../components/auth/controle'

function ControleLoggedScreen() {
        return (
            <Fragment>
                <Head titulo="Transparência - Controle Interno" />
                <HeaderLogged />
                <Container>
                   <ControleLogged />
                </Container>
                <Footer />
            </Fragment>
        );
}

export default ControleLoggedScreen;